import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import BrandLogo from '@/shared/assets/icons/logto-logo-dark.svg?react';
import LogtoSignature from '@/shared/components/LogtoSignature';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from './CustomContent';
import styles from './index.module.scss';

const AppLayout = () => {
  const { experienceSettings, theme, platform } = useContext(PageContext);
  const branding = experienceSettings?.branding;
  const hideLogtoBranding = experienceSettings?.hideLogtoBranding === true;

  return (
    <div
      className={classNames(
        styles.viewBox,
        platform === 'mobile' && styles.mobileView,
        styles.responsive
      )}
    >
      <div className={classNames(styles.container, layoutClassNames.pageContainer)}>
        <aside
          className={styles.promotion}
          aria-label="UnlimitAI"
          onContextMenu={(event) => {
            event.preventDefault();
          }}
          onDragStart={(event) => {
            event.preventDefault();
          }}
        >
          {branding?.promotionMediaUrl ? (
            branding.promotionMediaType === 'video' ? (
              // Brand media is supplemental; all authentication instructions remain available as text.
              // eslint-disable-next-line jsx-a11y/media-has-caption
              <video
                disablePictureInPicture
                disableRemotePlayback
                loop
                playsInline
                controls={false}
                controlsList="nodownload nofullscreen noremoteplayback"
                draggable={false}
                className={styles.media}
                src={branding.promotionMediaUrl}
                autoPlay={branding.promotionAutoplay ?? false}
                muted={!branding.promotionSoundEnabled}
                preload="metadata"
              />
            ) : (
              <img
                draggable={false}
                className={styles.media}
                src={branding.promotionMediaUrl}
                alt={branding.promotionTitle ?? 'UnlimitAI'}
              />
            )
          ) : (
            <div className={styles.brandArtwork} aria-hidden="true">
              <BrandLogo />
            </div>
          )}
          <div className={styles.promotionCopy}>
            <BrandLogo className={styles.promotionLogo} />
            {branding?.promotionTitle && <h1>{branding.promotionTitle}</h1>}
            {branding?.promotionDescription && <p>{branding.promotionDescription}</p>}
          </div>
          <CustomContent
            className={classNames(styles.customContent, layoutClassNames.customContent)}
          />
        </aside>
        <main className={styles.mainRegion}>
          <div className={styles.progressiveBlur} aria-hidden="true">
            {[2, 8, 18, 32, 50, 72].map((blur) => (
              <span key={blur} />
            ))}
          </div>
          <div className={classNames(styles.main, layoutClassNames.mainContent)}>
            <Outlet />
            {!hideLogtoBranding && (
              <LogtoSignature
                className={classNames(styles.signature, layoutClassNames.signature)}
                theme={theme}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
